import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_2 = {
  class: "create-entry"
};
import { ref, computed } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import superAgentLeft from './components/superAgentLeft.vue';
import superAgentRight from './components/superAgentRight.vue';
import { appProjectGetAppAppProject, appProjectDeleteAppProject } from '@/request/appProject';
import { useMainStore } from '@/pinia';
const loadingSvg = `
  <path class="path" d="
    M 30 15
    L 28 17
    M 25.61 25.61
    A 15 15, 0, 0, 1, 15 30
    A 15 15, 0, 1, 1, 27.99 7.5
    L 15 15
  " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
`;
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useMainStore();
    let configLoading = ref(false);
    let detailData = ref({});
    let leftActive = ref({});
    const handleClick = async (type, item) => {
      if (type === 'del') {
        try {
          await ElMessageBox.confirm('确认删除该智能体?', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          });
          await appProjectDeleteAppProject(item.id);
          leftActive.value = {};
          refreshData();
          ElMessage.success('操作成功');
        } catch (error) {
          // Handle cancel or error
        }
        return;
      }
      if (item !== null && item !== void 0 && item.id) {
        configLoading.value = true;
        try {
          const res = await appProjectGetAppAppProject(item.id);
          const {
            data,
            code
          } = res.data;
          if (code === 200 && data !== null && data !== void 0 && data.modelConfig) {
            const {
              provider,
              name
            } = data.modelConfig['model'];
            data.provider = provider;
            data.model = name;
            detailData.value = data;
          }
        } finally {
          setTimeout(() => {
            configLoading.value = false;
          }, 500);
        }
      } else {
        const orgId = store.userInfo.userId;
        detailData.value = {
          ...item,
          orgId
        };
      }
    };
    // 用于刷新
    const superAgentLeftRef = ref(null);
    let listLoading = ref(false);
    const refreshData = () => {
      if (superAgentLeftRef.value) {
        listLoading.value = true;
        superAgentLeftRef.value.appProjectGetAppAppProjectPageFn();
        setTimeout(() => {
          listLoading.value = false;
        }, 500);
      }
    };
    // 计算属性获取 agentList
    const agentList = computed(() => superAgentLeftRef.value ? superAgentLeftRef.value.agentList : []);
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_row, {
        class: "agent-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 5,
          style: {
            "width": "100%",
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(superAgentLeft, {
            ref_key: "superAgentLeftRef",
            ref: superAgentLeftRef,
            onHandleClick: handleClick,
            active: _unref(leftActive),
            "onUpdate:active": _cache[0] || (_cache[0] = $event => _isRef(leftActive) ? leftActive.value = $event : leftActive = $event),
            "element-loading-svg": loadingSvg,
            "element-loading-text": "加载中...",
            "element-loading-background": "rgba(0,0,0,0.5)",
            "element-loading-svg-view-box": "-10, -10, 50, 50"
          }, null, 8, ["active"]), [[_directive_loading, _unref(listLoading)]])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 19,
          style: {
            "width": "100%",
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(superAgentRight, {
              detailData: _unref(detailData),
              "onUpdate:detailData": _cache[1] || (_cache[1] = $event => _isRef(detailData) ? detailData.value = $event : detailData = $event),
              style: {
                "margin-left": "10px"
              },
              onRefreshData: refreshData,
              "element-loading-svg": loadingSvg,
              "element-loading-text": "配置加载中...",
              "element-loading-background": "rgba(0,0,0,0.5)",
              "element-loading-svg-view-box": "-10, -10, 50, 50"
            }, null, 8, ["detailData"]), [[_vShow, agentList.value.some(v => !v.systemDefault) || Object.keys(_unref(leftActive)).length], [_directive_loading, _unref(configLoading)]]), _withDirectives(_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "create-entry-bg"
            }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
              class: "icon"
            }, [_createElementVNode("i", {
              class: "ri-robot-line"
            })], -1)), _cache[5] || (_cache[5] = _createElementVNode("h1", null, "开启智能新纪元，探索无限潜能", -1)), _cache[6] || (_cache[6] = _createElementVNode("p", null, "在这里，您可以遇见最前沿的智能技术，体验前所未有的便捷与高效。让我们一起探索未来，共创智能生活新篇章。", -1)), _createElementVNode("div", {
              class: "create-button",
              onClick: _cache[2] || (_cache[2] =
              //@ts-ignore
              (...args) => superAgentLeftRef.value.handleClick && superAgentLeftRef.value.handleClick(...args))
            }, "立即创建您的专属智能体")], 512), [[_vShow, !(agentList.value.some(v => !v.systemDefault) || Object.keys(_unref(leftActive)).length)]])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});